import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { UserIcon, UsersIcon, CheckCircle2Icon } from 'lucide-react';
export function ResultsSection() {
  const forYou = ['Seguridad absoluta para responder cada "¿por qué?"', 'Ahorro de horas en planificación', 'Autoridad profesional'];
  const forStudents = ['Resultados más rápidos con técnica perfecta', 'Confianza total en tu trabajo', 'Prevención real de lesiones'];
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-209">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-210">
        <FadeIn className="text-center mb-10" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-gray-900" data-id="element-212">
            Lo que vas a lograr{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-213">
              vos y tus alumnos
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-214">
          <FadeIn delay={0.2} direction="up" data-id="element-215">
            <div className="bg-card border border-card-border rounded-2xl p-8 h-full" data-id="element-216">
              <div className="flex items-center gap-3 mb-6" data-id="element-217">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center" data-id="element-218">
                  <UserIcon className="w-6 h-6 text-primary" data-id="element-219" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-220">Para Vos</h3>
              </div>
              <ul className="space-y-4" data-id="element-221">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-222">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-223" />
                    <span className="text-gray-600 text-lg" data-id="element-224">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-225">
            <div className="bg-card border border-card-border rounded-2xl p-8 h-full" data-id="element-226">
              <div className="flex items-center gap-3 mb-6" data-id="element-227">
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center" data-id="element-228">
                  <UsersIcon className="w-6 h-6 text-secondary" data-id="element-229" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-230">
                  Para Tus Alumnos
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-231">
                {forStudents.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-232">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-233" />
                    <span className="text-gray-600 text-lg" data-id="element-234">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}